<template>
  <div class="w-full h-full">
    <el-radio-group v-model="activeKey" class="mt-10px mb-10px">
      <el-radio-button label="桥架列表"></el-radio-button>
      <el-radio-button label="电缆列表"></el-radio-button>
    </el-radio-group>
    <template v-if="activeKey === '电缆列表'">
      <cable
        :sourceId="sourceId"
        :player="player"
        :cloudRender="cloudRender"
        :transferProps="transferProps"
      ></cable>
    </template>

    <bridgeList
      v-else
      :player="player"
      :sourceId="sourceId"
      :cloudRender="cloudRender"
    ></bridgeList>
  </div>
</template>

<script>
import bridgeList from './index'
import cable from './cable.vue'

export default {
  name: 'NewBridgeCable',
  components: { bridgeList, cable },
  props: {
    /** 场景id */
    sourceId: {
      type: String,
      defalut: '',
    },
    player: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    cloudRender: {
      type: Object,
      default: () => {},
    },
    transferProps: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      loading: false,
      activeKey: '桥架列表',
    }
  },
  computed: {},
  methods: {},
}
</script>
<style lang="scss" scoped>
::v-deep .el-radio-button__inner {
  padding: 8px 30px;
}
::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background-color: #13b3c9;
  border-color: #13b3c9;
}
.el-button {
  color: #fff !important;
}
</style>
